<template>
    <div class="comboDialog-warp" v-loading="loading">
        <div class="content-warp">
            <div class="content-left">
                <el-input type="text" v-model="comboName" prefix-icon="el-icon-search" @input="search"></el-input>
                <div class="name-warp">
                    <div :class="item.comboId == currentItem.comboId ? 'name-item active' : 'name-item'"
                        v-for="item in comboRecipeList" :key="item.comboId" @click="chooseItem(item)">
                        <img :src="imgArr.bookIcon" class="book-icon">
                        <span>{{ item.comboName }}</span>
                    </div>
                </div>
            </div>
            <div class="content-right">
                <div class="right-title">{{ currentItem.comboName }}</div>
                <div class="drug-warp">
                    <el-row>
                        <el-col :span="6" v-for="item in currentItem.comboItems" :key="item.artNo">
                            <div class="grid-content bg-purple">
                                <div class="drug-name">{{ item.drugName }}</div>
                                <div class="drug-number">{{ item.number }} {{ item.unit }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="paging-warp">
            <el-pagination layout="prev, pager, next" :total="total" :current-page="1" @current-change="pageChange">
            </el-pagination>
        </div>
        <div class="btns">
            <div class="total-price">总价 ¥{{ currentItem.price }}</div>
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="user">使用</el-button>
        </div>
    </div>
</template>
  
<script>
import { comboRecipeList } from "@/api/combo"; // 隐秘处方请求
import { deepClone } from '@/utils/validateBase'
import { drugListByArtNo } from "@/api/drug"; // 药品请求
import { imgArr } from "@/assets/images/img";
export default {
    // 定义引入的组件
    components: {},
    props: {
        doctorInfo:Object,
        patientForm:Object
    },
    data() {
        return {
            imgArr: imgArr,
            comboName: '',//输入框内容
            loading: '',//加载动画
            currentPage: 1,//当前页
            pageSize: 10,//一页10条
            total: 0,//总数
            comboRecipeList: [],//隐秘处方列表
            currentItem: {},//当前隐秘处方对象
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
        this.getComboList()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        // 请求隐秘处方列表
        async getComboList() {
            this.loading = true
            let params = { pageNum: this.currentPage, pageSize: this.pageSize, comboName: this.comboName };
            let { rows, code, total } = await comboRecipeList(params);

            if (code == 200) {
                rows.forEach(item => {
                    item.comboItemLabels = '';
                    item.comboItems.forEach(kid => {
                        item.comboItemLabels += `${kid.drugName} ${kid.number} ${kid.unit}；`;
                    });
                });
                this.total = total;
                this.comboRecipeList = rows;
                this.currentItem = rows[0]
                this.loading = false;
            } else {
                this.loading = false;
            }
        },
        /**
         * 页码改变
         */
        pageChange(val) {
            this.currentPage = val
            this.getComboList()
        },
        /**
         * 搜索
         */
        search() {
            this.currentPage = 1;
            this.getComboList()
        },
        /**
         * 选择隐瞒处方
         */
        chooseItem(item) {
            this.currentItem = item
        },
        /**
         * 取消
         */
        cancel() {
            this.$emit('cancel')
        },
        /**
         * 使用
         */
        user() {
            let { comboName, price, comboItems, comboId } = this.currentItem;
            let { doctorId, doctorName } = this.doctorInfo;
            let { patientId, patientName } = this.patientForm;
            let recipeComboItems = [];
            let artNos = [];
            comboItems.forEach(item => {
                if (item.artNo != 0 && item.artNo != null && item.artNo != '') artNos.push(item.artNo);
            });
            this.loading = true
            drugListByArtNo({ deptId: this.$session.get('deptId'), artNos }).then(res => {
                let { code, data } = res
                if (code == 200) {
                    let { erroDrug, hospDrugs } = data
                    if (erroDrug.length > 0) {
                        let errDrugStr = ''
                        erroDrug.forEach(item => {
                            errDrugStr += (item.drugKindName + ',');
                        });
                        let msg = `当前隐秘处方无法开具，药品：${errDrugStr}库存不足。`;
                        this.$message.error(msg);
                    } else {
                        comboItems.forEach(item => {
                            let { artNo, comboItemId, drugName, number, unit, price, totalPrice } = item;
                            hospDrugs.forEach(kid => {
                                let { manufacturer, drugId, dictDrugCode } = kid;
                                if (kid.id == artNo) recipeComboItems.push({
                                    artNo,
                                    comboItemId,
                                    comboItemName: drugName,
                                    number,
                                    drugId,
                                    unit,
                                    price,
                                    manufacturer,
                                    totalPrice,
                                    dictDrugCode
                                });
                            });
                            if (item.artNo == 0) recipeComboItems.push({
                                artNo,
                                comboItemId,
                                comboItemName: drugName,
                                number,
                                unit,
                                price,
                                totalPrice,
                                drugId: 0,
                                manufacturer: '-',
                                dictDrugCode: '004800000030000-480000009'
                            });
                        });
                        // 隐秘处方
                        let comboItem = {
                            comboName,
                            price,
                            comboItems: recipeComboItems,
                            comboId,
                            totalPrice: price,
                            doseNumber: 1,
                            doctorName,
                            doctorId,
                            patientId,
                            patientName
                        }
                        this.$emit('userCombo', comboItem)
                    }
                    this.loading = false
                } else {
                    this.loading = false
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.comboDialog-warp {
    padding: 30px 20px;
    .content-warp {
        height: 500px;
        display: flex;

        .content-left {
            width: 290px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            border-right: 1px solid #E1E1E1;
            padding-right: 15px;

            .name-warp {
                flex: 1;
                margin-top: 16px;
                background: #F3F6FA;

                .name-item {
                    padding-left: 14px;
                    height: 34px;
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 14px;
                    cursor: pointer;

                    .book-icon {
                        width: 15px;
                        height: 15px;
                        flex-grow: 0;
                        flex-shrink: 0;
                        margin-right: 10px;
                    }
                }

                .active {
                    background: #E0EBFF;
                }
            }
        }

        .content-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 16px;

            .right-title {
                color: #333;
                font-size: 16px;
                flex-wrap: 500;
            }

            .drug-warp {
                width: 100%;
                margin-top: 40px;
                // border: 1px solid #E1E1E1;
                border-radius: 4px;
                box-sizing: border-box;

                .grid-content {
                    padding: 15px;
                    border-right: 1px dashed #E1E1E1;
                    border-bottom: 1px dashed #E1E1E1;
                    background: #F1F6FF;
                    box-sizing: border-box;

                    .drug-name {
                        color: #333;
                        font-size: 15px;
                        font-weight: 500;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .drug-number {
                        color: #666;
                        font-size: 14px;
                        font-weight: 400;
                    }
                }
            }
        }
    }

    .paging-warp {
        text-align: center;
    }

    .btns {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .total-price {
            color: #347EFF;
            font-size: 16px;
            margin-right: 15px;
        }

    }
}
</style>